import { css } from "@emotion/css";
import { Card, Col, Row } from "antd";
import React from "react";

function AdminSignupPageCard({ children, styled, responsive, width }) {
  return (
    <div
      style={{
        backgroundImage: `url("/pics/login/login_background.jpg")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // perspective: 1500,
      }}
      className={css`
        // width: 100vw;
        // height: 100vh;
        background: radial-gradient(
          circle at top,
          #815b72 3%,
          #2e1420 60%,
          #260a2f 109%
        );
        // position: fixed;
        // top: 0;
        // left: 0;
      `}
    >
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          width: "100%",
          //   margin: "50px 0",
        }}
        className={responsive}
      >
        <Col span={width || 20}>
          <Card
            className={css`
              opacity: 0;

              animation: fadeIn 0.5s forwards;
              @keyframes fadeIn {
                from {
                  opacity: 0;
                  transform: translateY(-20px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }
            `}
            style={styled}
          >
            {children}
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default AdminSignupPageCard;
